export const groupBy = <T, K extends keyof T>(array: T[], property: K) => {
    const map = new Map<T[K], T[]>();

    for (const element of array) {
        const key = element[property];

        const value = map.get(key);
        if (value) {
            map.set(key, value.concat(element));
        } else {
            map.set(key, [element]);
        }
    }

    return map;
};
